import React, { useState } from 'react';
import BaseModal from '../../../../components/modals/BaseModal';
import { Button, TextField, Grid } from '@mui/material';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import { useUserContext } from '../../../../context/user_context/UserContext';
import { useToast, ToastType } from '../../../../context/toast/ToastContext';
import { useTranslation } from 'react-i18next';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { addCategory } from '../../../../repository/ProductCategoriesDAO';

const AddProductCategoryModal = ({ show, onHide }) => {
    const [categoryName, setCategoryName] = useState("");
    const [description, setDescription] = useState("");
    const { setLoadingData } = useLoadingContext();
    const { firebaseUser } = useUserContext();
    const { showToast } = useToast();
    const { t } = useTranslation();

    const handleSubmit = async () => {
        if (!categoryName.trim()) {
            showToast(t(StringKeys.PRODUCT_CATEGORY_NAME_REQUIRED), ToastType.ERROR);
            return;
        }

        setLoadingData(true);
        const categoryData = {
            name: categoryName.trim(),
            description: description.trim(),
            created_by: firebaseUser.uid,
        };
    
        try {
            const result = await addCategory(firebaseUser.organization, categoryData);
            if (result.success) {
                showToast(t(StringKeys.SUCCESSFULLY_ADDED_X, {x: categoryName}), ToastType.SUCCESS);
                resetForm();
                onHide();
            } else {
                console.error(result);
                showToast(t(StringKeys.FAILED_TO_ADD_X, {x: categoryName}), ToastType.DANGER);
            }
        } catch (error) {
            console.error(error);
            showToast(t(StringKeys.FAILED_TO_ADD_X, {x: categoryName}), ToastType.DANGER);
        } finally {
            setLoadingData(false);
        }
    };
    
    const resetForm = () => {
        setCategoryName("");
        setDescription("");
    };

    return (
        <BaseModal
            open={show}
            onClose={() => {
                resetForm();
                onHide();
            }}
            maxWidth='sm'
            title={t(StringKeys.ADD_PRODUCT_CATEGORY)}
            actions={
                <>
                    <Button variant="contained" color="primary" onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
                </>
            }
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        autoFocus
                        margin="dense"
                        label={t(StringKeys.NAME)}
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        margin="dense"
                        label={t(StringKeys.DESCRIPTION)}
                        type="text"
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </Grid>
            </Grid>
        </BaseModal>
    );
};

export default AddProductCategoryModal;